// @ts-ignore
export const I18n = window.I18n